exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".report-option-group {\r\n  display: -webkit-inline-box;\r\n  display: -ms-inline-flexbox;\r\n  display: inline-flex;\r\n  -webkit-box-orient: vertical;\r\n  -webkit-box-direction: normal;\r\n      -ms-flex-flow: column nowrap;\r\n          flex-flow: column nowrap;\r\n}\r\n\r\n.report-option-button {\r\n  padding: 16px 8px;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/florian.gadal/Workspace/cinenow-web/src/app/profile/report-options-dialog/report-options-dialog.component.css
// module id = ../../../../../src/app/profile/report-options-dialog/report-options-dialog.component.css
// module chunks = 4